import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAllProcesses,
  setCurrentProcesses,
  setHasNewUpdate,
  acknowledgeProcess,
} from "./components/BackgroundActivitySlice";
import { CircularProgressBar } from "cpl-react-common/components/ActivityIndicators/BackgroundProcess/CircularProgressBar";
import { PageLink, PageTitle } from "_metronic/layout/core";
import { BackgroundServiceStatusType } from "cpl-react-common/components/Enums/BackgroundServiceStatusType";
import { getRedirectRouteForServiceType } from "./components/getRedirectRouteForServiceType";
import { useNavigate } from "react-router-dom";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

const backgroundActivitiesBreadCrumbs: Array<PageLink> = [
  {
    title: "Background Activities",
    path: "/BackgroundActivities",
    isSeparator: false,
    isActive: true,
  },
];

const BackgroundActivitiesPage: React.FC = () => {
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const processes = useSelector(selectAllProcesses);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHasNewUpdate(false));
  });

  function acknowledge(processID: number) {
    thunkDispatch(acknowledgeProcess(processID));
    dispatch(setCurrentProcesses(processes.filter((process) => process.processID !== processID)));
  }

  return (
    <>
      <PageTitle breadcrumbs={backgroundActivitiesBreadCrumbs}></PageTitle>
      <div className="card">
        <div className="card-header">
          <div className="card-title">Background Activities</div>
        </div>
        {(!processes || processes.length == 0) && (
          <div className="card-body">There are currently no active processes running.</div>
        )}
      </div>
      <div className="d-flex flex-wrap">
        {processes &&
          processes.map((process) => {
            return (
              <div key={process.processID} className="card w-50 w-md-25">
                <div className="card-body">
                  <CircularProgressBar processStatusResponse={process} />
                  {process.statusType !== BackgroundServiceStatusType.Running && (
                    <div
                      data-test-id={`background-activities-page__clear-process-button-${process.processID}`}
                      className="btn btn-sm btn-primary me-1"
                      onClick={() => acknowledge(process!.processID)}
                    >
                      Clear process
                    </div>
                  )}
                  {process.statusType !== BackgroundServiceStatusType.Failed && (
                    <div
                      data-test-id={`background-activities-page__go-to-process-button-${process.processID}`}
                      className="btn btn-sm btn-success"
                      onClick={() => {
                        acknowledge(process!.processID);
                        navigate(getRedirectRouteForServiceType(process!.serviceType));
                      }}
                    >
                      Go to process
                    </div>
                  )}
                  {process.statusType === BackgroundServiceStatusType.Failed && (
                    <div
                      data-test-id={`background-activities-page__go-to-process-button-${process.processID}`}
                      className="btn btn-sm btn-danger"
                      onClick={() => navigate(getRedirectRouteForServiceType(process!.serviceType))}
                    >
                      Go To process
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default BackgroundActivitiesPage;
